import * as Yup from "yup";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  makeStyles,
} from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { useMutation, useQuery } from "react-query";

import CustomAlert from "../../../components/CustomAlert";
import CustomDialog from "../../../components/CustomDialog";
import { Autocomplete as FormikAutocomplete } from "formik-material-ui-lab";
import { KeyboardDatePicker as FormikKeyboardDatePicker } from "formik-material-ui-pickers";
import { TextField as FormikTextField } from "formik-material-ui";
import dayjs from "dayjs";
import { fetchPortNames } from "../../../../services/portNamesServices";
import { updateShipRecordHdService } from "../../../../services/shipRecordHdService";
import useLocale from "../../../../hooks/useLocale";
import GovGrModal from "../../../../components/GovGrModal";
import GovGrTextField from "../../../../components/GovGrTextField";
import GovGrDate from "../../../../components/GovGrDate";
import GovGrSelectBox from "../../../../components/GovGrSelectBox";
import GovGrButton from "../../../../components/GovGrButton";

const useStyles = makeStyles({
  dateContainer: {
    width: "100%",
  },
});
function UpdateDialog({
  open,
  close,
  refreshTable,
  selectedItem,
  ship_data_id,
}) {
  const { t } = useLocale();
  const [error, setError] = useState("");
  // dayjs().locale(locale === "el-GR" ? localeEl : localeEn);
  const classes = useStyles();
  // Mutation for creating data
  const { mutate } = useMutation(updateShipRecordHdService, {
    onSuccess: (data) => {
      refreshTable();
      close();
    },
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured. Please try again later"));
        }
      }
    },
  });

  const { data: portNames } = useQuery("portNames", fetchPortNames);

  // Initial values
  const initialValues = {
    ship_data_id: ship_data_id,
    record_port: selectedItem?.record_port,
    aa: selectedItem.rh_aa,
    prev_record_id: selectedItem?.rh_prev_record_id,
    issue_date: new Date(selectedItem.rh_issue_date),
    sail_until_dt: new Date(selectedItem.rh_sail_until_dt),
    record_place: selectedItem?.record_place,
  };

  const shipRecordHdFormValidation = Yup.object().shape({
    record_port: Yup.object({
      id: Yup.string().required(t("Field is required")).nullable(),
    })
      .typeError(t("Field is required"))
      .required(t("Field is required")),
    aa: Yup.number()
      .typeError("Number required")
      .required(t("Field is required"))
      .nullable(),
    // prev_record_id: Yup.string().required(t("Field is required")),
    issue_date: Yup.date().nullable().required(t("Field is required")),
    record_place: Yup.object({
      id: Yup.string().required(t("Field is required")).nullable(),
    })
      .typeError(t("Field is required"))
      .required(t("Field is required")),
  });

  const handleUpdateItem = (values) => {
    const valuesToSend = {
      ship_data_id: parseInt(ship_data_id),
      record_port_id: values?.record_port?.id,
      aa: values.aa,
      prev_record_id: values?.prev_record_id,
      issue_date: dayjs(values?.issue_date).format("YYYY-MM-DD"),
      sail_until_dt: dayjs(values?.sail_until_dt).format("YYYY-MM-DD"),
      record_place_id: values?.record_place?.id,
    };

    mutate({ id: selectedItem?.rh_id, ...valuesToSend });
  };

  return (
    <GovGrModal open={open} onClose={close} customContent="true">
      <div className="govgr-heading-l m-0">
        {t("Update the Nautical Crew List")}
      </div>
      <CustomAlert
        open={!!error}
        close={() => {
          setError("");
        }}
        message={t("A network error occured, please try again later")}
      />
      <Formik
        initialValues={initialValues}
        validationSchema={shipRecordHdFormValidation}
        enableReinitialize
        onSubmit={(values, { setSubmitting }) => {
          handleUpdateItem(values);
          setSubmitting(false);
        }}
      >
        {({ submitForm }) => (
          <Form>
            <DialogContent>
              <GovGrSelectBox
                name="record_port"
                options={portNames || []}
                optionlabel="name"
                label={t("Issue Port")}
              />
              <GovGrTextField
                name="aa"
                label={t("Nautical Crew's List Number")}
              />
              <div className={classes.dateContainer}>
                <GovGrDate label={t("Issue Date")} name="issue_date" />
              </div>
              <div className={classes.dateContainer}>
                <GovGrDate label={t("Sail until")} name="sail_until_dt" />
              </div>
              <GovGrSelectBox
                name="record_place"
                options={portNames || []}
                optionlabel="name"
                label={t("Record Place")}
              />
            </DialogContent>
            <DialogActions>
              <GovGrButton
                onClick={submitForm}
                variant="primary"
                buttonText={t("Update")}
              />
              <GovGrButton
                onClick={close}
                variant="secondary"
                buttonText={t("Cancel")}
              />
            </DialogActions>
          </Form>
        )}
      </Formik>
    </GovGrModal>
  );
}

export default UpdateDialog;
